import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Domains from "@/pages/Domains";
import BuyDomains from "@/pages/BuyDomains";
import Orders from "@/pages/Orders";
import Logs from "@/pages/Logs";
import Settings from "@/pages/Settings";
import CloudflareSettings from "@/pages/CloudflareSettings";
import CpanelPage from "@/pages/CpanelPage";
import AdspectPage from "@/pages/AdspectPage";
import AdspectLogsPage from "@/pages/AdspectLogsPage";
import QuickDeployPage from "@/pages/QuickDeployPage";
import UsersPage from "@/pages/UsersPage";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/domains" element={<ProtectedRoute><Domains /></ProtectedRoute>} />
            <Route path="/buy" element={<ProtectedRoute><BuyDomains /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
            <Route path="/logs" element={<ProtectedRoute><Logs /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/cloudflare" element={<ProtectedRoute><CloudflareSettings /></ProtectedRoute>} />
            <Route path="/cpanel" element={<ProtectedRoute><CpanelPage /></ProtectedRoute>} />
            <Route path="/adspect" element={<ProtectedRoute><AdspectPage /></ProtectedRoute>} />
            <Route path="/adspect/logs" element={<ProtectedRoute><AdspectLogsPage /></ProtectedRoute>} />
            <Route path="/deploy" element={<ProtectedRoute><QuickDeployPage /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
          </Routes>
          <Toaster position="bottom-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
